"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.conversation = exports.brandName = void 0;
const util_1 = require("../util");
exports.brandName = 'conversationCustomOperation';
function _conversation(input) {
    return { ...(0, util_1.brand)(exports.brandName), ...input };
}
/**
 * @experimental
 *
 * Define an AI conversation route which enables multi-turn conversation APIs for interacting with specified AI model.
 * @example
 * realtorChat: a.conversation({
 *   aiModel: { resourcePath },
 *   systemPrompt: 'You are a helpful real estate assistant',
 * })
 * @returns a conversation route definition
 */
function conversation(input) {
    return _conversation(input);
}
exports.conversation = conversation;
